import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCategoryIndicatorsList = createAsyncThunk("fetchCategoryIndicatorsList", async (language = "en") => {
	const response = await axiosHttp.get(`vision/category-indicator/list?lang=${language}`);
	return response.data.data;
});

const CategoryIndicatorsListSlice = createSlice({
	name: "CategoryIndicatorsListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchCategoryIndicatorsList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchCategoryIndicatorsList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchCategoryIndicatorsList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default CategoryIndicatorsListSlice.reducer;
